import { EditNotificationsOutlined } from "@mui/icons-material"
import { Box, Button, Typography, useTheme } from "@mui/material"
import { DataGrid, GridDeleteIcon } from "@mui/x-data-grid"
import { useEffect, useState } from "react"
import ConfirmationDialog from "../../components/ConfirmationDialog"
import Header from "../../components/Header"
import ModuleCategoryApi from "../../services/api/moduleCategories"
import { tokens } from "../../theme"
import ModuleCategoryForm from "./form"

const ModuleCategories = () => {
	const theme = useTheme()
	const colors = tokens(theme.palette.mode)
	const api = ModuleCategoryApi()
	const [entitiesList, setEntitiesList] = useState([])

	const [isConfirmationOpen, setConfirmationOpen] = useState(false)
	const [selectedId, setSelectedId] = useState("")
	const [editingEntity, setEditingEntity] = useState()

	const [open, setOpen] = useState(false)

	const columns = [
		{ field: "id", headerName: "ID" },
		{
			field: "name",
			headerName: "Name",
			flex: 1,
			cellClassName: "name-column--cell",
		},
		{
			field: "order_no",
			headerName: "Order Number",
			flex: 1,
		},
		{
			field: "",
			headerName: "Edit",
			flex: 1,
			renderCell: ({ row: { id } }) => {
				return (
					<Box display="flex" justifyContent="center" borderRadius="4px">
						<Typography
							variant="button"
							color="warning"
							onClick={() => editEntity(id)}
							style={{ cursor: "pointer", marginRight: "10px" }}
						>
							<EditNotificationsOutlined
								fontSize="small"
								style={{ marginRight: "4px" }}
							/>
							Edit
						</Typography>

						<Typography
							variant="button"
							color="error"
							onClick={() => deleteEntity(id)}
							style={{ cursor: "pointer" }}
						>
							<GridDeleteIcon fontSize="small" style={{ marginRight: "4px" }} />
							Delete
						</Typography>
					</Box>
				)
			},
		},
	]

	useEffect(() => {
		fetchData()
	}, [])

	const fetchData = async () => {
		try {
			const data = await api.getAll()

			setEntitiesList(data.results)
		} catch (error) {
			console.log(fetchErrorMsg, error)
		}
	}

	const editEntity = (id) => {
		const project = entitiesList.find((row) => row.id === id)
		setEditingEntity(project)
		viewForm()
	}

	const deleteEntity = (id) => {
		setSelectedId(id)
		handleOpenConfirmation()
	}

	const handleOpenConfirmation = () => {
		setConfirmationOpen(true)
	}

	const handleCloseConfirmation = () => {
		setConfirmationOpen(false)
	}

	const handleConfirmAction = () => {
		try {
			const response = api.destroy(selectedId)

			console.log(deletedSuccessMsg, response)
			fetchData()
		} catch (error) {
			console.log(deleteErrorMsg, error)
		}

		handleCloseConfirmation()
	}

	const openCreateForm = () => {
		setEditingEntity()
		viewForm()
	}

	const viewForm = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
		fetchData()
	}

	return (
		<>
			<Box m="20px">
				<Header title="Module Categories" subtitle="" />

				<Box display="flex" justifyContent="end" m="0 0 0 0">
					<Button
						type="submit"
						color="secondary"
						variant="contained"
						onClick={openCreateForm}
					>
						Create Module Category
					</Button>
				</Box>

				<Box
					m="40px 0 0 0"
					height="75vh"
					sx={{
						"& .MuiDataGrid-root": {
							border: "none",
						},
						"& .MuiDataGrid-cell": {
							borderBottom: "none",
						},
						"& .name-column--cell": {
							color: colors.greenAccent[300],
						},
						"& .MuiDataGrid-columnHeaders": {
							backgroundColor: colors.blueAccent[700],
							borderBottom: "none",
						},
						"& .MuiDataGrid-virtualScroller": {
							backgroundColor: colors.primary[400],
						},
						"& .MuiDataGrid-footerContainer": {
							borderTop: "none",
							backgroundColor: colors.blueAccent[700],
						},
						"& .MuiCheckbox-root": {
							color: `${colors.greenAccent[200]} !important`,
						},
					}}
				>
					<DataGrid rows={entitiesList} columns={columns} />
				</Box>
			</Box>

			<ConfirmationDialog
				open={isConfirmationOpen}
				onClose={handleCloseConfirmation}
				onConfirm={handleConfirmAction}
			/>

			<ModuleCategoryForm
				formData={editingEntity}
				open={open}
				handleClose={() => handleClose()}
			/>
		</>
	)
}

const deletedSuccessMsg = "Module category deleted successfully: "
const deleteErrorMsg = "Not deleted module category. "
const fetchErrorMsg = "Not loading module category"

export default ModuleCategories
